import React from "react";

function BarGraphSVG(classes: any) {
  return (
    <svg
      width="30"
      height="36"
      viewBox="0 0 54 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3929 57.5H4.46432C3.87232 57.5 3.30457 57.2366 2.88596 56.7678C2.46735 56.2989 2.23218 55.663 2.23218 55V35C2.23218 34.337 2.46735 33.7011 2.88596 33.2322C3.30457 32.7634 3.87232 32.5 4.46432 32.5H13.3929C13.9849 32.5 14.5526 32.7634 14.9713 33.2322C15.3899 33.7011 15.625 34.337 15.625 35V55C15.625 55.663 15.3899 56.2989 14.9713 56.7678C14.5526 57.2366 13.9849 57.5 13.3929 57.5Z"
        fill="#88FEC3"
      />
      <path
        d="M31.7857 57.5H22.8571C22.2651 57.5 21.6974 57.2366 21.2788 56.7678C20.8602 56.2989 20.625 55.663 20.625 55V5C20.625 4.33696 20.8602 3.70107 21.2788 3.23223C21.6974 2.76339 22.2651 2.5 22.8571 2.5H31.7857C32.3777 2.5 32.9455 2.76339 33.3641 3.23223C33.7827 3.70107 34.0179 4.33696 34.0179 5V55C34.0179 55.663 33.7827 56.2989 33.3641 56.7678C32.9455 57.2366 32.3777 57.5 31.7857 57.5Z"
        fill="#232323"
      />
      <path
        d="M50.1785 57.5H41.25C40.658 57.5 40.0902 57.2366 39.6716 56.7678C39.253 56.2989 39.0178 55.663 39.0178 55V25C39.0178 24.337 39.253 23.7011 39.6716 23.2322C40.0902 22.7634 40.658 22.5 41.25 22.5H50.1785C50.7705 22.5 51.3383 22.7634 51.7569 23.2322C52.1755 23.7011 52.4107 24.337 52.4107 25V55C52.4107 55.663 52.1755 56.2989 51.7569 56.7678C51.3383 57.2366 50.7705 57.5 50.1785 57.5Z"
        fill="#21FF91"
      />
    </svg>
  );
}

export default BarGraphSVG;
